import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SupportModalIdComponent } from '@lib/components/support-class';
import { DialogClickType } from '@lib/interfaces';
import { ModalSamplePayload } from './modal-sample.state';

@Component({
  selector: 'asw-modal-sample',
  templateUrl: './modal-sample.component.html',
  styleUrls: ['./modal-sample.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalSampleComponent extends SupportModalIdComponent {
  public subPageId: string = 'M001';
  public subFunctionId: string = 'S01';
  public override payload: ModalSamplePayload | null = {};
  reload(): void {
    // throw new Error('Method not implemented.');
  }
  init(): void {
    // throw new Error('Method not implemented.');
  }
  destroy(): void {
    // throw new Error('Method not implemented.');
  }
  clickModalSample() {
    // confirm('onModalSample000000');
    // this.router.navigate([SearchRoutes.bookingList])
  }
  handleConfirmClick() {
    if (this.payload?.submitEvent) {
      this.payload.submitEvent('lang');
    }
    this.close();
  }
  handleCancelClick() {
    if (this.payload?.closeEvent) {
      this.payload.closeEvent();
    }
    this.close();
  }
}
